<template>
    <div class="page linkman">
        <!-- 头部 -->
        <head-bar title="下单联系人" :fixed="true">
            <template v-slot:right>
                <div class="head-right-slot">
                    <span @click="handleAdd">新增</span>
                </div>
            </template>
        </head-bar>
        <!-- 内容 -->
        <div class="content">
            <div v-if="info.length > 0" class="linkman-list">
                <ul>
                    <li v-for="(item, index) in info" :key="index">
                        <span>{{ item.linkmanName }}</span>
                        <span>{{ item.linkmanPhone }}</span>
                        <van-tag type="primary" v-if="item.defaultFlag"
                            >默认
                        </van-tag>
                        <i
                            class="linkman-edit-icon"
                            @click="handleEdit(item.linkmanId)"
                        >
                        </i>
                    </li>
                </ul>
            </div>
            <empty-data
                v-else
                iconText="暂无下单联系人"
                :iconSrc="emptyIcon"
                :paddingTop="8"
                iconSize="slim"
            />
        </div>
    </div>
</template>

<script>
import HeadBar from "@/components/HeadBar";
import EmptyData from "@/components/EmptyData";
import Vue from "vue";
import { Field, Tag, Toast } from "vant";

Vue.use(Field);
Vue.use(Tag).use(Toast);

export default {
    name: "Linkman",
    components: { HeadBar, EmptyData },
    data() {
        return {
            // 空数据icon
            emptyIcon: require("../../../public/images/user/address/linkman-null.png"),
            info: [], // 页面信息
        };
    },
    created() {
        this.getPageInfo();
    },
    methods: {
        /* 获取页面信息 */
        getPageInfo() {
            let _this = this;
            const url = this.$api.userApi.queryLinkmanListApi;
            const params = {
                operation: "select",
            };
            _this.$toast.loading({
                message: "数据加载中...",
                duration: 0,
            });
            this.$axios.post(url, params).then((res) => {
                this.info = res.data || [];
                _this.$toast.clear();
            });
        },
        /* 新增 */
        handleAdd() {
            this.$router.push("/user/linkman/edit");
        },
        /* 编辑 */
        handleEdit(id) {
            this.$router.push({
                path: "/user/linkman/edit",
                query: { id },
            });
        },
    },
};
</script>

<style lang="less" scoped>
.linkman {
    .head-right-slot {
        text-align: right;
        padding-right: 20px;
        font-size: 32px;
    }

    .content {
        padding-top: 20px;

        .linkman-list {
            background: #fff;

            ul {
                li {
                    font-size: 28px;
                    line-height: 100px;
                    margin: 0 30px;
                    border-top: 1px solid #f2f2f2;
                    position: relative;

                    &:first-child {
                        border-top: none;
                    }

                    span {
                        margin-right: 20px;
                    }

                    .van-tag--primary {
                        background-color: #54b0fd;
                    }

                    .linkman-edit-icon {
                        position: absolute;
                        top: 50%;
                        right: 0;
                        transform: translateY(-50%);
                        width: 48px;
                        height: 48px;
                        background: url(../../../public/images/user/address/linkman-edit-icon.png)
                            center no-repeat;
                        background-size: 100%;
                    }
                }
            }
        }
    }
}
</style>
